
import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';


const QnaComponent = lazy(() => import('../../pages/Qna/containers/QnaPageContainer'));
const QnaCreateComponent = lazy(() => import('../../pages/Qna/containers/QnaCreatePageContainer'));
const QnaDetailComponent = lazy(() => import('../../pages/Qna/containers/QnaDetailPageContainer'));

const route = [
  {
    path: ROUTERS.QNA,
    title: 'Qna List',
    exact: true,
    public: false,
    component: <QnaComponent />,
  },
  {
    path: ROUTERS.QNA_CREATE,
    title: 'Qna Create',
    exact: true,
    public: false,
    component: <QnaCreateComponent />,
  },
  {
    path: ROUTERS.QNA_DETAIL,
    title: 'Qna Detail',
    exact: true,
    public: false,
    component: <QnaDetailComponent />,
  }
];

export default route;